// @flow
import React from "react";
import { connect } from "react-redux";
import { errors } from "buba-components";
import RefreshPasswordView from "buba-components/src/views/RefreshPassword";
import { isBankAdvisorPasswordRegex } from "buba-components/src/utils/regexes";
import { refreshPassword } from "buba-components/src/api/actions";

import { getUserToken } from "../../store/user/selectors";
import { passwordRefreshed as passwordRefreshedAction } from "../../store/user/actions";
import paths from "../../data/paths";

type RefreshPasswordProps = {
  token: string,
  passwordRefreshed: typeof passwordRefreshedAction
};

const handleSubmit =
  (token, passwordRefreshed) => (values, handleRedirect, mapFormErrors, showFlashMessage) =>
    refreshPassword(values.old_password, values.password, values.password_confirmation, token)
      .then(passwordRefreshed)
      .then(handleRedirect)
      .catch(err => {
        if (err && err.response && err.response.status) {
          if (err.response.status === 422) {
            mapFormErrors(err.response);
          } else {
            showFlashMessage(
              "Das Passwort konnte nicht geändert werden. Bitte ausloggen and loggen Sie sich erneut ein."
            );
          }
        }
      });

const RefreshPassword = ({ token, passwordRefreshed, ...props }: RefreshPasswordProps) => {
  return (
    <RefreshPasswordView
      passwordRegex={isBankAdvisorPasswordRegex}
      passwordError={errors.isPasswordExtended()}
      defaultRedirectPath={paths.bankInquiriesListNew}
      onSubmit={handleSubmit(token, passwordRefreshed)}
      {...props}
    />
  );
};

export default connect(state => ({ token: getUserToken(state) }), {
  passwordRefreshed: passwordRefreshedAction
})(RefreshPassword);
